export const findIntersection = function (arrays: any[][]) {
  return arrays.reduce((common, current) => 
    common.filter(element => current.includes(element))
  );
}